/* Rquiere de mixin.js */

var client = {
	data() {
		return {
			objectClient: {
				exists: 0,
				id: 0,
				name: '',
				surname: '',
				email: '',
				phone: '',
				birthdate: '',
				number_document: '',
				type_client_id: 1,
				type_client: '',
				client_price_list: [],
				type_colportor_id: null,
				type_colportor: null,
				address: []
			},
			listClients: [],
			listPriceListsClient: [],
			messageErrorSave: {
				success: false,
				message: '',
				data: []
			},
			methodsClient: {
				create: 'client/register',
				delete: '/delete',
				get: 'clients',
				show: 'client/',
				update: 'client/update',
				priceList: '/priceList',
			},
			paginationClients: [],
			searchClients: '',
			qRowsClient: 25,
			searchingClient: false,
			savingClient: false
		}
	},
	computed: {
	},
	filters: {
	},
	methods: {
		addListClients(newClient) {
			this.listClients.push(newClient)
		},
		changeQRowsClient() {
			localStorage.setItem('qRowsClient', this.qRowsClient)
			this.getAllClients()
		},
		clearObjectClient() {
			this.objectClient.exists = 0
			this.objectClient.id = 0
			this.objectClient.name = ''
			this.objectClient.surname = ''
			this.objectClient.email = ''
			this.objectClient.phone = ''
			this.objectClient.birthdate = ''
			this.objectClient.number_document = ''
			this.objectClient.type_client_id = 1
			this.objectClient.type_client = ''
			this.objectClient.type_colportor_id = null
			this.objectClient.type_colportor = null
			this.objectClient.client_price_list = []
			this.objectClient.address = []
		},
		clearMessageErrorSave() {
			this.messageErrorSave.success = false
			this.messageErrorSave.message = ''
			this.messageErrorSave.data = []
		},
		deleteClient(id) {
			this.$emit('showLockScreen', 'Borrando cliente . . .')
			this.axiosActionIS(this.getApiBackend + this.methodsClient.show + id + this.methodsClient.delete, 'DELETE', 'deleteClientResult')
		},
		deleteClientPriceListResult(response) {
			this.deleteItemClientPriceList(response.data.data)
		},
		deleteItemListClients(id) {
			let index = this.listClients.map((el) => parseInt(el.id)).indexOf(parseInt(id))
			if (index > -1)
				return this.listClients.splice(index, 1)
			return false
		},
		deleteItemClientPriceList(id) {
			let index = this.objectClient.client_price_list.map((el) => parseInt(el.price_list_id)).indexOf(parseInt(id))
			if (index > -1)
				return this.objectClient.client_price_list.splice(index, 1)
			return false
		},
		getClientForNumberDocument(documentNumber) {
			let param = '?documentNumber=' + documentNumber
			let url = this.getApiBackend + 'client/getByDocumentNumber' + param
			this.axiosActionIS(url, 'GET', 'getClientForNumberDocumentResult')
		},
		getClientForNumberDocumentResult(response) {
			if (response.data.success == true) {
				this.setObjectClient(response.data.data)
			} else {
				console.log(response.data)
			}
			this.getClientForNumberDocumentResultLocal(response)
		},
		getClientForNumberDocumentResultLocal(response) {
			console.log('getClientForNumberDocumentResultLocal no desarrollado', response)
		},
		getAllClients(page = 1) {
			this.$emit('showLockScreen', 'Obteniendo lista de clientes . . .')
			let parameters = '?search=' + this.searchClients + '&page=' + page + '&qRow=' + this.qRowsClient
			this.axiosActionIS(this.getApiBackend + this.methodsClient.get + parameters, 'GET', 'getAllClientsResult')
		},
		getAllPriceListsClient(id) {
			this.axiosActionIS(this.getApiBackend + this.methodsClient.show + id + this.methodsClient.priceList, 'GET', 'getAllPriceListsClientResult')
		},
		getAllPriceListsClientResult(response) {
			this.listPriceListsClient = response.data.data
			this.getAllPriceListsClientResultLocal(response)
		},
		getAllPriceListsClientResultLocal(response) {
			console.log('getAllPriceListsClientResultLocal no desarrollado', response)
		},
		saveClient(item) {
			this.savingClient = true
			let method = (item.exists == 0) ? 'POST' : 'PUT'
			this.$emit('showLockScreen', 'Guardando datos . . .')
			if (method == 'POST') {
				this.axiosActionIS(this.getApiBackend + this.methodsClient.create, method, 'saveClientPOSTResult', item)
			} else if (method == 'PUT') {
				this.axiosActionIS(this.getApiBackend + this.methodsClient.show + item.id, method, 'saveClientPUTResult', item)
			}
		},
		deleteClientResult(response) {
			if (response.data.success) {
				this.deleteItemListClients(response.data.data)
				this.socketEmit(['DELETE_CLIENT'], response.data.data)
				this.clearObjectClient()
			}
		},
		getAllClientsResult(response) {
			if (response.data.success === true) {
				this.listClients = response.data.data
				this.paginationClients = response.data.paginate
			}
		},
		saveClientResult(response) {
			this.savingClient = false
			if (!response.data.success) {
				this.$snotify.error(response.data.data, response.data.message)
			} else {
				if (response.data.message == 'NUEVO') {
					this.$snotify.success('Cliente creado con el código ' + response.data.data.id, 'Nuevo Cliente')
					this.setObjectClient(response.data.data)
					this.addListClients(response.data.data)
					this.socketEmit(['NEW_CLIENT'], response.data.data)
				} else if (response.data.message == 'ACTUALIZADO') {
					this.$snotify.info('Se ha actualizado el cliente ' + response.data.data.id + ' con exito!!!', 'Actualizado')
					this.updateItemListClients(response.data.data)
					this.socketEmit(['UPDATE_CLIENT'], response.data.data)
				}
				this.saveClientResultLocal(response)
			}
		},
		saveClientResultLocal(response) {
			console.log('saveClientResultLocal no desarrollado', response)
		},
		setClientAddressSend(id, addressId) {
			let url = this.getApiBackend + this.methodsClient.show + id + '/address/' + addressId + '/send'
			this.axiosActionIS(url, 'PUT', 'setClientAddressSendResult', null)
		},
		setClientAddressSendResult(response) {
			if (response.data.success == true) {
				this.$snotify.info('Seleccion realizada')
			}
			this.setClientAddressSendResultLocal(response)
		},
		setClientAddressSendResultLocal(response) {
			console.log('setClientAddressSendResultLocal no desarrollado', response)
		},
		setErrorSaveClientLocal(response) {
			console.groupCollapsed('Error!!! Resultado de consulta axios, funcion por omision (setErrorSaveClientLocal)')
			console.log(response)
			console.groupEnd()
		},
		setObjectClient(item) {
			for (const property in item) {
				this.objectClient[property] = item[property]
			}
		},
		showClient(id, action = 'view') {
			this.searchingClient = true
			let param = '?action=' + action
			this.axiosActionIS(this.getApiBackend + this.methodsClient.show + id + param, 'GET', 'showClientResult', null)
		},
		showClientResult(response) {
			this.searchingClient = false
			if (response.data.success == true) {
				this.setObjectClient(response.data.data)
			}
			this.showClientResultLocal(response)
		},
		showClientResultLocal(response) {
			console.log('showClientResultLocal no desarrollado', response)
		},
		updateItemListClients(item) {
			let index = this.listClients.map((el) => parseInt(el.id)).indexOf(parseInt(item.id))
			if (index > -1) {
				for (const property in item) {
					this.listClients[index][property] = item[property]
				}
			}
			if (this.objectClient.id == item.id) {
				this.setObjectClient(item)
			}
		},
	},
};

export default client;